import { httpMethods } from '@/pages/api/helpers';
import { logError, logWarning } from '@/utils/miscUtils';
import { getLogger } from '@/logging/logger';

export default async function postMarketingData(
    url: string,
	body: any,
    headers: { [key: string]: string } = {},
    ) {

    const logger = getLogger('app');

    try {
        const response = await fetch(url, {
			method: httpMethods.POST,
			body: JSON.stringify(body),
			headers: headers
		});
        logger.info(`marketing-data: ${body}`);
            
		return response;
	} catch (err) {
		logWarning(`Could not post quiz to userEvents api`);
        logger.info('/marketing-data failed ' + err);
		if (err instanceof Error) {
			logError(`USER_EVENTS_URL: ${err.message}`);
		}
	}
}
